import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import NISProductFinePrint from "@tCentro/Components/NISProductFinePrintText";
import * as React from "react";

type Props = WidgetProps & HasProduct;

const NISProductFinitePrintText: React.FC<Props> = ({ product }) => {
    if (!product?.properties) {
        return null;
    }

    return (
        <StyledWrapper>
            {product.properties.finePrint && <NISProductFinePrint finePrint={product.properties.finePrint} />}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(NISProductFinitePrintText),
    definition: {
        displayName: "NIS Product Fine Print Text",
        group: "Product Details",
    },
};

export default widgetModule;
